<div class="p-4 border-0 rounded-4">
  <div class="card-body">
    <h5 class="card-title text-center fw-bold mb-3">Upload Your File</h5>

    <form [formGroup]="fileUploadForm" (ngSubmit)="onSubmit($event)">
      <div class="mb-3">
        <label for="file" class="form-label fw-semibold">Select File:</label>
        <div
          class="input-group"
          style="border: 1px solid #ccc; border-radius: 4px"
        >
          <input
            type="file"
            class="form-control"
            id="file"
            (change)="onFileChange($event)"
            style="
              border: 0;
              background: #d0cfce;
              border-radius: 4px;
              line-height: 28px;
            "
          />
        </div>
      </div>

      <button
        type="submit"
        class="btn primary w-100 py-2"
        [disabled]="!fileUploadForm.valid"
      >
        Upload File
      </button>
    </form>
  </div>
</div>
